// --------------------------------------------------------
// RelationsshipGHE - RelationshipGHE
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
import React, { useCallback, useEffect, useState } from "react";
import ContainerWithSidebar from "../../components/UI/containerWithSidebar/ContainerWithSidebar";
import {
  GeneralContainer,
  H1,
  H3,
  Text,
  TextLink,
  TitleLarge,
} from "../../components/UI/generalLayout/Layout.styled";
import ScreenHeader from "../../components/UI/screenHeader/ScreenHeader";
import { ContainerGHE, ViewFilter } from "./RelationshipGHE.styled";
import CareLineDropdown from "../../components/dropdown/CareLineDropdown";
import CardListGhe from "../../components/cardListGhe/CardListGhe";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  CircularProgress,
  FormControl,
  InputAdornment,
  OutlinedInput,
} from "@mui/material";
import Search from "@mui/icons-material/Search";
import { useSelector } from "react-redux";
import * as relationShip from "../../store/actions/relationshipGhe";
import { useAppDispatch } from "../..";
import Company from "../../models/core/company/Company";
import Colors from "../../constants/Colors";
import { Paths } from "../../enums/Paths";
import useResponsiveInfo from "../../hooks/useResponsiveInfo";
import { useNavigate } from "react-router-dom";
import OccupationalHealth from "../../models/core/occupationalHealth/OccupationalHealth";

// --------------------------------------------------------
// RelationsshipGHE INTERFACE
// --------------------------------------------------------
/**
 * A component that renders a Screen.
 *
 * @param props Properties
 * @param props.route The route
 * @param props.navigation The navigator
 * @returns The component JSX.
 */
import BackButton from "../../components/UI/buttons/BackButton";

function RelationshipGHE(): JSX.Element {
  // --------------------------------------------------------
  // RelationsshipGHE PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const [selectSO, setSelectSO] = useState<any>([]);
  const [reletationShipFilter, setReletationShipFilter] = useState("");
  const [dropdownDisabled, setDropdownDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const occupationalHealthList: OccupationalHealth[] = useSelector((state: any)=>state.occupationalHealth.occupHealthList);

  const { isMobile } = useResponsiveInfo();
  const navigate = useNavigate();

  const currentCompany: Company = useSelector(
    (state: any) => state.login.currentCompany
  );

  const arraySaude: any[] = useSelector(
    (state: any) => state.relationShip.arraySaude
  );

  const arraySaudeMenu: any[] = useSelector(
    (state: any) => state.relationShip.arraySaudeMenu
  );

  const arrayOneRelationShip: any[] = useSelector(
    (state: any) => state.relationShip.arrayOneRelationShip
  );

  const dispatch = useAppDispatch();

  // Busca todos os postos de trabalho com a relação Ghes e com a empresa
  const fetchRelationShips = useCallback(async () => {
    await dispatch(relationShip.FetchRelationship(currentCompany.id, occupationalHealthList));
    setIsLoading(false);
  }, [dispatch, reletationShipFilter, currentCompany]);

  // Filtrar Ghes
  const filterByGhe = useCallback(async () => {
    setIsLoading(true);
    if (selectSO.id === "") {
      fetchRelationShips();
    } else {
      await dispatch(
        relationShip.filterGhes(currentCompany.id, arraySaude, selectSO, occupationalHealthList)
      );
      setIsLoading(false);
    }
  }, [selectSO, currentCompany, dispatch]);

  // Filtrar Postos de trabalho.
  const fetchRelationShipsFilter = useCallback(async () => {
    setIsLoading(true);
    reletationShipFilter.length > 0 ? setDropdownDisabled(true) : setDropdownDisabled(false);

    if (reletationShipFilter.length > 0 || reletationShipFilter === '') {
      await dispatch(
        relationShip.filterRelationShipList(
          currentCompany.id,
          reletationShipFilter,
          occupationalHealthList
        )
      );
    } 

    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, [reletationShipFilter]);

  // Limpar filtros
  const atualizarStates = () => {
    setIsLoading(true);
    setSelectSO([]);
    setReletationShipFilter("");
    fetchRelationShips();
  };

  // USESTATES
  useEffect(() => {
    fetchRelationShipsFilter();
  }, [reletationShipFilter]);

  useEffect(() => {
    filterByGhe();
  }, [selectSO]);

  useEffect(() => {
    fetchRelationShips();
  }, []);

  return (
    <ContainerWithSidebar>
      <GeneralContainer>
        <BackButton onClick={() => navigate(Paths.CollaboratorInitial)} />
        <ScreenHeader
          screenTitle={'Postos de Trabalho'}
          hasRightButton={false}
          rightButtonText=""
          onRightButtonClick={() => {}}
        />
        <ContainerGHE>
        <ViewFilter margin={20} isMaxColumn={true}>
          <div>
            <FormControl fullWidth sx={{ m: 1 }}>
              <OutlinedInput
                style={{ borderRadius: "10px", width: "350px" }}
                id="outlined-adornment-amount"
                startAdornment={
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                }
                label=""
                placeholder="Buscar posto de trabalho"
                value={reletationShipFilter}
                disabled={
                  selectSO.id === "" || selectSO.length === 0 ? false : true
                }
                onChange={(event: any) => {
                  setReletationShipFilter(event.target.value);
                }}
              />
            </FormControl>
          </div>
          <div>
            <CareLineDropdown
              placeholder="Selecionar Saúde Ocupacional"
              value={selectSO}
              onChange={setSelectSO}
              disabled={dropdownDisabled ? true : false}
              items={arraySaudeMenu}
              style={{ width: "353px", height: "53px" }}
            />
          </div>
        </ViewFilter>
        {reletationShipFilter.length >= 3 && (
          <div style={{ paddingLeft: 40 }}>
            <Text color={Colors.lightBlue}>
              Resultados para: {reletationShipFilter}{" "}
            </Text>
          </div>
        )}
        {!isMobile && (
          <ViewFilter margin={20}>
            <H3>Nome</H3>
            <H3>Relacionar Saúde Ocupacional</H3>
          </ViewFilter>
        )}

        {!isLoading ? (
          <>
            {" "}
            {arrayOneRelationShip !== null &&
            arrayOneRelationShip.length > 0 ? (
              <>
                {arrayOneRelationShip.map((d, index) => {
                  return (
                    <>
                      <CardListGhe
                        data={d}
                        saudesOcupacionais={arraySaude}
                        id={d.postoTrabalhoId}
                        idSaude={d.saudeOcupacionalId}
                        idRelation={d.id}
                        nomePosto={d.nome}
                        attRelationShip={atualizarStates}
                        key={index}
                      />
                    </>
                  );
                })}
              </>
            ) : (
              <Text>Nenhum resultado encontrado</Text>
            )}
          </>
        ) : (
          <div style={{ textAlign: "center", marginTop: 10 }}>
            <CircularProgress />
          </div>
        )}
      </ContainerGHE>
      </GeneralContainer>
    </ContainerWithSidebar>
  );
}

export default RelationshipGHE;
